import styled from "styled-components";
import { Flex } from "../Flex/Flex.js";
import { IconButton } from "../IconButton/IconButton.js";

export const ModalOverlay = styled.div<{ elevation?: number }>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${({ theme, elevation }) => elevation ?? theme.elevationLevels.six};
`;

export const ModalContent = styled(Flex)<{ noPadding?: boolean; noSizeConstraint?: boolean; fullscreen?: boolean }>`
    background-color: ${(props) => props.theme.grayscale.white};
    border-radius: ${(props) => (props.fullscreen ? "0" : props.theme.radius.l)};
    box-shadow: ${(props) => props.theme.shadows.popover};
    position: relative;
    padding: ${(props) => (props.noPadding ? "0" : props.theme.spacing[40])};
    gap: ${(props) => props.theme.spacing[20]};
    overflow: hidden;

    ${({ fullscreen, noSizeConstraint }) =>
        !fullscreen &&
        !noSizeConstraint &&
        `
            min-width: 300px;
            max-width: 90%;
            max-height: 95vh;
        `}
`;

export const CloseButton = styled(IconButton)`
    position: absolute;
    top: ${(props) => props.theme.spacing[20]};
    right: ${(props) => props.theme.spacing[20]};
    z-index: ${(props) => props.theme.elevationLevels.nine};
`;

export const ModalBody = styled(Flex)``;
